module.exports = __webpack_public_path__ + "linea-basic-10.e6763f008205c55db623.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/linea-icons/fonts/linea-basic-10.ttf
// module id = ../../../../../theme/scss/icons/linea-icons/fonts/linea-basic-10.ttf
// module chunks = styles